// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ju-z","tooltipWrapper":"Ku-z","icon":"Lu-z","tooltip":"Mu-z","content":"Nu-z"};